import styled from 'styled-components';
import {
  SYS_PAGE_MARGIN_XS,
  SYS_PAGE_MARGIN_MD,
  SYS_PAGE_MARGIN_XL,
  SYS_SPACE_RELATIVE_XL,
  SYS_SPACE_RELATIVE_MD,
} from '@oneaudi/unified-web-common';
import { getResponsiveSpacing, createMediaQuery } from '../../utils';

export const GroupContainer = styled.ul`
  box-sizing: border-box;
  width: calc(100%-30px);
  padding: 0px;
  grid-template-columns: repeat(3, 1fr);
  flex-direction: column;
  ${createMediaQuery({
    margin: {
      xs: `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_XS}`,
      l: `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_MD}`,
      xl: `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_XL}`,
    },
    display: {
      xs: 'flex',
      m: 'grid',
    },
    'column-gap': SYS_SPACE_RELATIVE_MD,
  })}

  & a {
    ${(props) =>
      createMediaQuery({
        'margin-top': {
          xs: getResponsiveSpacing('xs')(props) || '8px',
          m: getResponsiveSpacing('m')(props) || '16px',
          xl: getResponsiveSpacing('l')(props) || '24px',
        },
      })}
  }

  & a:first-child {
    margin-top: ${SYS_SPACE_RELATIVE_MD};
  }
`;
